import { Action } from '@ngrx/store';

export class UserProfileActions implements Action {

    public static update: string = '[User] update';
    public static updateError: string = '[User] updateError';
    public static updateSuccess: string = '[User] updateSuccess';

    public static updateVirtualUser: string = '[User] updateVirtualUser';

    public static updatePatch: string = '[User] updatePatch';
    public static updatePatchError: string = '[User] updatePatchError';
    public static updatePatchSuccess: string = '[User] updatePatchSuccess';

    public static updateTags: string = '[User] updateTags';
    public static updateTagsError: string = '[User] updateTagsError';
    public static updateTagsSuccess: string = '[User] updateTagsSuccess';

    public static updateCompany: string = '[User] updateCompany';
    public static updateCompanyError: string = '[User] updateCompanyError';
    public static updateCompanySuccess: string = '[User] updateCompanySuccess';

    public static lazyUpdate: string = '[User] lazyUpdate';
    public static lazyUpdateSuccess: string = '[User] lazyUpdateSuccess';

    public static insertBankSuccess: string = '[User] insertBankSuccess';
    public static deleteBankSuccess: string = '[User] deleteBankSuccess';

    public static reset: string = '[User] reset';

    public static getUser: string = '[User] get';
    public static getUserByCBLC: string = '[User] get_user_by_cblc';
    public static getUserToroUser: string = '[User] get_user_toro_user';
    public static getttingUser: string = '[User] getting_user';
    public static getUserError: string = '[User] getError';
    public static getUserSuccess: string = '[User] getSuccess';

    public static getCompany: string = '[User] getCompany';
    public static getCompanyError: string = '[User] getCompanyError';
    public static getCompanySuccess: string = '[User] getCompanySuccess';

    public static getRiskModel: string = '[User] get_risk_model';
    public static getRiskModelError: string = '[User] get_risk_model_error';
    public static getRiskModelSuccess: string = '[User] get_risk_model_success';

    public static getGarantyModel: string = '[User] get_garanty_model';
    public static getGarantyModelError: string = '[User] get_garanty_model_error';
    public static getGarantyModelSuccess: string = '[User] get_garanty_model_success';

    public static updateRiskModel: string = '[User] update_risk_model';
    public static updateRiskModelError: string = '[User] update_risk_model_error';
    public static updateRiskModelSuccess: string = '[User] update_risk_model_success';

    public static updatePhone: string = '[User] update_phone';
    public static updatePhoneError: string = '[User] update_phone_error';
    public static updatePhoneSuccess: string = '[User] update_phone_success';

    public static notifyConclusion: string = '[User] notify_conclusion';
    public static notifyConclusionError: string = '[User] notify_conclusion_error';
    public static notifyConclusionSuccess: string = '[User] notify_conclusion_success';

    public static saveUpdatesReregister: string = '[User] save_updates_reregister';

    public static sendRegistration: string          = '[User] send_registration';

    public static getTrader: string = '[User] get_trader';
    public static getTraderError: string = '[User] get_trader_error';
    public static getTraderSuccess: string = '[User] get_trader_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
